module.exports = __webpack_public_path__ + "img/banner_join.46564aec.jpg";